/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-07-29 14:32:43
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2025-05-23 15:54:51
 * @FilePath: /qd-yunjing-web/src/api/modules/ibms.ts
 * @Description:ibms yemian
 */
import { $request } from '@/utils/request';
import type { AlarmInfoType } from '@/types';
import servers from '../servers';

/**
 * @description: 获取摄像头列表片
 */
export const listProjectPointMonitorInfo = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/ruleMgtType/listProjectPointMonitorInfo`,
  method: 'POST',
  data,
});

/**
 * @description: 获取职能规则列表
 */
export const getQualityControlEquipments = (data = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getQualityControlEquipments`,
  method: 'post',
  data,
});
/**
 * @description: 智能规则详情
 */
export const getArRuleInfo = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getDicts`,
  method: 'get',
  params,
});
/**
 * @description: 智能规则详情
 */
export const getAiRuleInfo = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getDicts`,
  method: 'get',
  params,
});
/**
 * @description: 获取系统
 */
export const getFireDicts = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getFireDicts`,
  method: 'get',
  params,
});
/**
 * @description: 获取类型
 */
export const getEquipTypes = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getEquipTypes`,
  method: 'get',
  params,
});

/**
 * @description: 获取设备详细信息
 */
export const getEquipmentPoint = (params = {}) => $request<ResponseData<AlarmInfoType[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getEquipmentPoint`,
  method: 'get',
  params,
});

// 历史数据查询 结果查询
export const historySearch = (params = {}) => $request<ResponseData<any[]>>({
  url: `${servers.ibms}/api/history/history-data-value`,
  method: 'get',
  params,
});

// 品质管理-根据属性获取设备
export const getQualityControlDicts = (params = {}) => $request<ResponseData<any[]>>({
  url: `${servers.ibms}/api/equipmentMonitor/getQualityControlDicts`,
  method: 'get',
  params,
});
/**
 * @description: 获取消防系统类型
 */
export const getFireAlarmType = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/yj/alarm/fireAlarmType`,
  method: 'get',
  params,
});

/**
 * @description: 摄像头设备列表 - 获取视频设备列表
 */
export const getVideoDeviceListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras/page`,
  method: 'post',
  data,
});

/**
 * @description:功能空间列表
 */
export const getSpaceListRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras/space-attrs`,
  method: 'post',
  data,
});

// 考评标签列表
export function getSysDictListByType(params: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/work-order-type/type`,
    method: 'get',
    params,
  });
}

/**
 * @description:记录播放记录
 */
export const playRecordRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras/play-log-record`,
  method: 'post',
  data,
});

/**
 * @description:获取播放记录
 */
export const getPlayHistoryRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/cameras/play-log`,
  method: 'get',
  params,
});

/**
 * @description:发送工单
 */
export const submitEvaluationRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.qdInsight}/api/v1/work-order/create`,
  method: 'post',
  data,
});

/**
 * @description:获取摄像头图片
 */
export const snapshotScreen = (params = {}) => $request<ResponseData>({
  url: `${servers.video}/monitor/rule/snapshot`,
  method: 'get',
  params,
});

/**
 * @description:保存点位画框
 */
export const saveOrUpdateMask = (data = {}) => $request<ResponseData>({
  url: `${servers.video}/monitor/pointMask/saveOrUpdateMask`,
  method: 'post',
  data,
});
/**
 * @description:获取点位画框数据
 */
export const getPointMask = (params = {}) => $request<ResponseData>({
  url: `${servers.video}/monitor/pointMask/getPointMask`,
  method: 'get',
  params,
});

/**
 * @description:获取点位画框数据
 */
export const getPointLabels = (params = {}) => $request<ResponseData>({
  url: `${servers.video}/monitor/pointMask/getPointLabels`,
  method: 'get',
  params,
});

/**
 * @description: 规则详情
 */
export function getCameraPicRequest(params: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/rule/camera-pic`,
    method: 'get',
    params,
  });
}

/**
 * @description: 规则详情
 */
export function putCameraPicRequest(data: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/rule/camera-pic`,
    method: 'PUT',
    data,
  });
}

/**
 * @description: 抓图
 */
export function screenshotRequest(data: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/cameras/screenshot`,
    method: 'POST',
    data,
  });
}

/**
 * @description: 播放成功后的记录次数
 */
export function addPalyLogRequest(data: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/play-log/add`,
    method: 'POST',
    data,
  });
}

/**
 * @description: 播放时间的统计
 */
export function putPalyLogRequest(data: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/play-log/update`,
    method: 'PUT',
    data,
  });
}

/**
 * @description: 楼层统计摄像头
 */
export function getCameraBySpaceRequest(params: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/cameras/stat-per-space`,
    method: 'get',
    params,
  });
}
/**
 * @description: 收藏摄像头
 */
export function addDeviceFavotiteRequest(data: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/device-favotite`,
    method: 'POST',
    data,
  });
}

/**
 * @description: 根据ID查询场景模板
 * @param
 * @returns
 */
export function getAiScreenTemplateRequest(params: any): any {
  return $request({
    url: `${servers.qdInsight}/api/v1/scene-template`,
    method: 'get',
    params,
  });
}
